import React from 'react'

import {
  EurIcon,
  FacebookIcon,
  FacebookPartnerIcon,
  TelegramEurIcon,
  TelegramIcon,
  TelegramTonIcon,
  TikTokIcon,
  UsdIcon,
} from '../components/Icons'

export enum IconTypes {
  FACEBOOK = 'facebook',
  TIKTOK = 'tiktok',
  BALANCE_USD = 'balance_usd',
  BALANCE_EUR = 'balance_eur',
  TELEGRAM = 'telegram',
  DOLLAR = 'dollar',
  BALANCE = 'balance',
  EURO = 'euro',
  EUR = 'EUR',
  USD = 'USD',
  TELEGRAM_TON = 'telegram_ton',
  TELEGRAM_EUR = 'telegram_eur',
}

export const getPlatformIcon = (
  iconType: IconTypes | string | null,
  isAlternativeIcon?: boolean,
  isTonTelegram?: boolean
) => {
  const telegramIcon = isTonTelegram ? <TelegramTonIcon /> : <TelegramEurIcon />

  switch (iconType) {
    case IconTypes.FACEBOOK:
      return isAlternativeIcon ? <FacebookPartnerIcon /> : <FacebookIcon />
    case IconTypes.TIKTOK:
      return <TikTokIcon />
    case IconTypes.BALANCE_EUR:
      return <EurIcon />
    case IconTypes.BALANCE_USD:
      return <UsdIcon />
    case IconTypes.TELEGRAM:
      return isAlternativeIcon ? telegramIcon : <TelegramIcon />
    case IconTypes.DOLLAR:
      return <UsdIcon />
    case IconTypes.BALANCE:
      return <UsdIcon />
    case IconTypes.EURO:
      return <EurIcon />
    case IconTypes.EUR:
      return <EurIcon />
    case IconTypes.USD:
      return <UsdIcon />
    case IconTypes.TELEGRAM_TON:
      return <TelegramTonIcon />
    case IconTypes.TELEGRAM_EUR:
      return <TelegramEurIcon />
    default:
      return null
  }
}
